import * as React from 'react'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'
import { ThunkDispatch } from 'redux-thunk'
import { IApplicationState } from 'redux/store/store'
import { Loader } from 'shared/components/Loader'
import {
  formatDate,
  comparableDate,
} from 'shared/service/helpers/DateUtilities'
import {
  clearDataActionCreator,
  getAfleverafsprakenCreator,
  IClearDataResponseAction,
  IGetAfleverafsprakenDataResponseAction,
} from 'redux/store/actions/aarZonderLocatieAction'
import { IKlantAfleverafspraak } from 'shared/models/IKlantAfleverafspraak'
import { ExportToCsv } from 'export-to-csv-fix-source-map'
import { exceloptions } from 'shared/models/Enum'

interface IProps {
  requestData: () => Promise<IGetAfleverafsprakenDataResponseAction>
  clearData: (message: string) => Promise<IClearDataResponseAction>
  afleverafspraken: IKlantAfleverafspraak[]
  schermloading: boolean
  foutmelding: string
}

const AarZonderLocatieLijst: React.FunctionComponent<IProps> = ({
  requestData,
  clearData,
  afleverafspraken,
  schermloading,
  foutmelding,
}) => {
  const zoekAfleverafspraken = () => {
    if (canSearch()) {
      requestData()
    }
  }

  const canSearch = (): boolean => {
    return true
  }

  const exportToCsv = () => {
    const csvExporter = new ExportToCsv(exceloptions)
    csvExporter.generateCsv(
      afleverafspraken.map(a => {
        return {
          AfspraakAanmaakdatum: formatDate(a.aanmaakDatumtijd),
          Klantnummer: a.klant.klantNummer,
          Klantnaam: a.klant.klantNaam,
          KlantEAN: a.klant.klantEanCode,
          KlantIngangsdatum: formatDate(a.klant.ingangsDatum),
          KlantEinddatum: formatDate(a.klant.eindDatum),
          Afspraakreferentie: a.afleverafspraakReferentie,
          Afspraaknaam: a.naam,
          AfspraakIngangsdatum: formatDate(a.ingangsDatum),
          AfspraakEinddatum: formatDate(a.eindDatum),
        }
      })
    )
  }

  const renderAgreements = (agreements: IKlantAfleverafspraak[]) => {
    return (
      <table className='table ml-4'>
        <thead>
          <tr className='tablesubheader'>
            <th colSpan={10}>
              <div className='row'>
                <div className='col-auto'>Afleverafspraken</div>
                <div className='col-auto'>
                  <button className='btn btn-info' onClick={exportToCsv}>
                    Excel
                  </button>
                </div>
                <div className='col'></div>
              </div>
            </th>
          </tr>
          <tr className='tablesubheader'>
            <th colSpan={5}>Klant</th>
            <th colSpan={5}>Afleverafspraak</th>
          </tr>
        </thead>
        <tbody>
          <tr className='tablesubheader'>
            <td>Klantnr.</td>
            <td>Naam</td>
            <td>EAN</td>
            <td>Ingangsdatum</td>
            <td>Einddatum</td>
            <td>Aanmaakdatum</td>
            <td>Afspraakreferentie</td>
            <td>Afspraaknaam</td>
            <td>Ingangsdatum</td>
            <td>Einddatum</td>
          </tr>
          {agreements
            .sort((a, b) =>
              comparableDate(formatDate(a.aanmaakDatumtijd)) <
              comparableDate(formatDate(b.aanmaakDatumtijd))
                ? 1
                : comparableDate(formatDate(a.aanmaakDatumtijd)) >
                  comparableDate(formatDate(b.aanmaakDatumtijd))
                ? -1
                : a.klant.klantNummer > b.klant.klantNummer
                ? 1
                : a.klant.klantNummer < b.klant.klantNummer
                ? -1
                : a.afleverafspraakReferentie > b.afleverafspraakReferentie
                ? 1
                : -1
            )
            .map(a => (
              <tr key={a.klantAfleverafspraakId}>
                <td>{a.klant.klantNummer}</td>
                <td
                  className='mw-200 overflow-hidden'
                  title={a.klant.klantNaam}
                >
                  {a.klant.klantNaam}
                </td>
                <td>{a.klant.klantEanCode}</td>
                <td>{formatDate(a.klant.ingangsDatum)}</td>
                <td>{formatDate(a.klant.eindDatum)}</td>
                <td>{formatDate(a.aanmaakDatumtijd)}</td>
                <td>{a.afleverafspraakReferentie}</td>
                <td>{a.naam}</td>
                <td>{formatDate(a.ingangsDatum)}</td>
                <td>{formatDate(a.eindDatum)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    )
  }

  return (
    <div>
      <h2>Overzicht kopers zonder gekoppelde locatie(s)</h2>

      <div>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button
                      className='btn btn-primary'
                      disabled={!canSearch()}
                      onClick={zoekAfleverafspraken}
                    >
                      Zoek
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {!!afleverafspraken && <div>{renderAgreements(afleverafspraken)}</div>}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.aarZonderLocatieState.loading,
    afleverafspraken: store.aarZonderLocatieState.afleverafspraken,
    foutmelding: store.aarZonderLocatieState.foutmelding,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: () => dispatch(getAfleverafsprakenCreator()),
    clearData: (message: string) => dispatch(clearDataActionCreator(message)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AarZonderLocatieLijst)
